import Button from '../Button/Button'
import ClausePreview from '@shared/components/HoverPreview'
import type { ParserLink } from '@shared/lib/parser/parser'
import { getRefPath } from '@shared/lib/parser/refUrl'

type RefButtonProps = ParserLink & {
  openInNewTab?: boolean
  id: string
  documentType?: string
  [key: string]: unknown
}

export default function RefButton({
  id,
  openInNewTab,
  ...rest
}: RefButtonProps) {
  return (
    <ClausePreview id={id}>
      <Button
        size='small'
        variant='accent'
        href={getRefPath({ id, ...rest } as unknown as ParserLink)}
        target={openInNewTab ? '_blank' : undefined}
      >
        {rest.citation}
      </Button>
    </ClausePreview>
  )
}
